import { render, staticRenderFns } from "./ImportDeliveryNoteForm.vue?vue&type=template&id=6a4817a2&scoped=true&"
import script from "./ImportDeliveryNoteForm.vue?vue&type=script&lang=js&"
export * from "./ImportDeliveryNoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4817a2",
  null
  
)

export default component.exports